import { PantallaPendiente } from "@components/ui_v2";

export const ExpedienteAutorizadoPendiente = () => (
  <PantallaPendiente
    eyebrow="Formalización · Expediente autorizado"
    title="¡Tu expediente está autorizado!"
    subtitle="Revisamos toda tu información y documentos. En breve podrás continuar con el siguiente paso."
  />
);
